import React from 'react'
import { DrillsCategoriesLoader } from 'loaders'
import PropTypes from 'prop-types'
import DrillsCategoriesContainer from './DrillsCategoriesContainer'

const DrillsCategories = ({ location, match }) => (
  <DrillsCategoriesLoader>
    <DrillsCategoriesContainer location={location} match={match} />
  </DrillsCategoriesLoader>
)

DrillsCategories.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
}

export default DrillsCategories
